(() => {
  const TRANSITION_DURATION = 240;
  const LEAVING_CLASS = "peguu-footer-page-leaving";
  const ENTERING_CLASS = "peguu-footer-page-entering";
  const TRANSITION_STORAGE_KEY = "peguu:footer-page-transition";

  const restorePage = () => {
    document.body.classList.remove(LEAVING_CLASS);
  };

  if (sessionStorage.getItem(TRANSITION_STORAGE_KEY) === "true") {
    sessionStorage.removeItem(TRANSITION_STORAGE_KEY);
    document.body.classList.add(ENTERING_CLASS);

    window.setTimeout(() => {
      document.body.classList.remove(ENTERING_CLASS);
    }, TRANSITION_DURATION);
  }

  window.addEventListener("pageshow", restorePage);

  if (document.documentElement.dataset.peguuFooterTransitionBound === "true") {
    return;
  }

  document.documentElement.dataset.peguuFooterTransitionBound = "true";

  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-peguu-footer-transition]");

    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const destination = new URL(link.href, window.location.href);

    if (
      destination.origin !== window.location.origin ||
      destination.href === window.location.href
    ) {
      return;
    }

    event.preventDefault();

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.location.assign(destination.href);
      return;
    }

    sessionStorage.setItem(TRANSITION_STORAGE_KEY, "true");
    document.body.classList.add(LEAVING_CLASS);

    window.setTimeout(() => {
      window.location.assign(destination.href);
    }, TRANSITION_DURATION);
  });
})();
